import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import cx from 'classname';
import styles from './customselect.module.scss';
import Dropdown from 'components/Dropdown';
import Dropdownbody, {
  stylesForDropDown,
} from 'components/Dropdown/dropdownbody';
import { UpChevron, DownChevron } from 'assets/svgs';
import { ErrorIcon } from '../../../assets/svgs';

const CustomSelect = (props) => {
  const { selectProps, name, clearErrors, defaultValue = '', label } = props;
  const options = Array.isArray(props.options) ? props.options : [];
  const [selected, setSelected] = useState(defaultValue);
  const [isOpen, setIsOpen] = useState(false);
  const valueLabelMapping = options.reduce((acc, obj) => {
    acc[obj.value] = obj.text;
    return acc;
  }, {});

  const handleSelect = (item) => {
    setSelected(item.value);
    props.handleClick(item);
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    setSelected(defaultValue);
  }, [defaultValue]);

  useEffect(() => {
    const element = document.getElementById(name);
    if (element) {
      element.value = selected;
      if (clearErrors) {
        clearErrors(name);
      }
    }
  }, [clearErrors, name, selected]);
  return (
    <div data-testid="custom-select">
      <select
        {...selectProps}
        id={name}
        name={name}
        className={styles.htmlselect}
      >
        <option key={-1} value={null}></option>
        {options.map((item) => (
          <option key={item.value} value={item.value}>
            {item.text}
          </option>
        ))}
      </select>

      <div className={styles.selectGroup}>
        <Dropdown
          header={
            <div className={styles.select}>
              <label htmlFor={props.name}>{props.label}</label>
              <div
                className={cx(
                  props.variant === 'blue'
                    ? styles.selectBlue
                    : styles.selectDef,
                  isOpen ? styles.selectButtonOpen : '',
                  selected ? styles.selected : '',
                )}
                onClick={() => setIsOpen(!isOpen)}
                data-testid={props.testid}
              >
                {!selected ? (
                  <p className={styles.selectButtonDefault}>
                    {props.placeholder ? props.placeholder : 'Select'}
                  </p>
                ) : (
                  <p className={styles.selectButtonSelected}>
                    {valueLabelMapping[selected] ||
                      valueLabelMapping[props.defaulValue]}
                  </p>
                )}
                <span style={{ marginLeft: '20px' }}>
                  {isOpen ? <UpChevron /> : <DownChevron />}
                </span>
              </div>
            </div>
          }
          isOpen={isOpen}
          setIsOpen={setIsOpen}
        >
          <Dropdownbody>
            {props?.options?.map((item, i) => (
              <button
                type="button"
                className={stylesForDropDown.dropdownitem}
                style={{ width: '100%' }}
                onClick={() => handleSelect(item)}
                key={item.text}
                data-testid={`${props.testid}SelectItem`}
              >
                <p className={stylesForDropDown.dropdownitemtext}>
                  {item.text}
                </p>
              </button>
            ))}
          </Dropdownbody>
        </Dropdown>
        {props.error && (
          <p className={styles.error}>
            <ErrorIcon />
            {props.error}
          </p>
        )}
      </div>
    </div>
  );
};

CustomSelect.propTypes = {
  options: PropTypes.array.isRequired,
  handleClick: PropTypes.func.isRequired,
};

export default CustomSelect;
